import { apiClient } from './apiClient'

// apiClient baseURL is e.g. https://sakeena.life:4090/api

export interface ChatStatus {
  enabled: boolean
}

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
}

export interface ChatRequest {
  message: string
  conversationHistory?: ChatMessage[]
}

export interface ChatResponse {
  reply: string
}

export async function getChatStatus(): Promise<ChatStatus> {
  const { data } = await apiClient.get<ChatStatus>('chat/status')
  return data
}

export async function sendChatMessage(request: ChatRequest): Promise<ChatResponse> {
  const { data } = await apiClient.post<ChatResponse>('chat', request)
  return data
}
